import React,{useState} from "react";
import CText from "../../common/CText";
import { ScrollView, View } from "react-native";
import CImage from "../../common/CImage";
import Common from "../../common/Common";
import { COLORS } from "../../constant";
import Loader from "../../common/Loader";
import ModalAlert from "../../common/ModalAlert";
import { getApplicationStatus } from "../../api/usedCarLoan";
import CHeader from "../../common/CHeader";
import { CreateResponsiveStyle,  DEVICE_SIZES,  useDeviceSize,} from "rn-responsive-styles";

export default function TrackStatusApplications(props) {
    const styles = useStyles()
    const [loading, setLoading] = useState(false)
    const [alertModalVisible, setAlertModalVisible] = useState(false);
    const [alertModal, setAlertModal] = useState({
        title: "",
        status: "",
        message: "",
        navigateScreen: "",
        navigate: '',
        actionButton: "",
    });
    let applicationIdList = [];
    if (props && props.applicationIds) {
        applicationIdList = props.applicationIds;
    }
    if (!(applicationIdList.length > 0)) {
        props.setActiveScreen("TrackStatus");
    }

    const onPressApplication = (applicationId) => {
        setLoading(true);
        getApplicationStatus({ applicationId, type: "usedCarLoan" }).then(res => {
          setLoading(false);
          if (res?.statusCode === 1071) {
            props.setStatusData(res);
            props.setActiveScreen("StatusBlock");
          } else {
            setAlertModalVisible(true)
            setAlertModal({
                title: "Error",
                status: "error",
                message: res.message,
                navigateScreen: "",
                actionButton: "OK",
            });
          }
        }).catch(err => {
          console.log("getApplicationStatus Error:", err);
          setLoading(false);
        })
    }

    return (
        <>
            <View>
                <CHeader onPress = {props.setActiveScreen} title = "Back"  navigation = "TrackStatus"></CHeader>
            </View>

            <View style={styles.contentWrapper}>

                <View style={styles.carImageWrapper}>
                    <View style={{ paddingVertical: 6 }}>
                        <CText.usedCarLoanHeader>Track Loan Status</CText.usedCarLoanHeader>
                    </View>
                    <View style={styles.carImage}><CImage.usedCarLoanIndex /></View>
                </View>

                <View style={styles.applyLoanWrapper}>
                    <ScrollView showsVerticalScrollIndicator={false}>
                    {applicationIdList.length > 0 ?
                        <View style={styles.mobileViewStyle}>
                            {applicationIdList.map((appItem) => {
                                let statusTitle = "Loan Processed";
                                let subTitle = ''
                                let statusIcon = <CImage.roundArrowGreenIcon />;
                                let statusStyle = { borderColor: "green" };
                                if (appItem.status === "Pending") {
                                    statusTitle = "Application Incomplete";
                                    statusStyle = { borderColor: "orange" };
                                } else if (appItem.status === "Rejected") {
                                    statusTitle = "Application Rejected";
                                    statusStyle = { borderColor: COLORS.primary };
                                }
                                if (appItem.loanUpdateStatus == 'inProgress'){
                                    subTitle = 'Click here to proceed further'
                                }
                                return (
                                    <Common.trackStatusCard
                                        styles={{ borderWidth: 1,width:'100%', ...statusStyle }}
                                        key1="Application Id"
                                        value1={appItem.applicationId}
                                        onPress={() => onPressApplication(appItem.applicationId)}
                                        img2={statusIcon}
                                        subTitle = {subTitle}
                                    />);

                            })}
                        </View> : <></>}
                        </ScrollView>
                </View>
            </View>
            {loading ? <Loader /> : ""}
            {alertModalVisible && (
                <View style={styles.overlayViewStyle}>
                    <ModalAlert
                        title={alertModal.title}
                        status={alertModal.status}
                        message={alertModal.message}
                        navigateScreen={alertModal.navigateScreen}
                        actionButton={"OK"}
                        onCloseModal={() => setAlertModalVisible(false)}
                    />
                </View>
            )}
        </>

    )
}
const useStyles = CreateResponsiveStyle({
    contentWrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingTop: 40,
        justifyContent: "space-between",
        paddingHorizontal: "15%"
    },
    overlayViewStyle: {
        position: "absolute",
        zIndex: 9999,
        backgroundColor: "rgba(52,52,52,0.9)",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        borderRadius: 10,
      },    
    carImage: {
        marginTop: 20
    },
    carImageWrapper: {
        alignItems: "center",
    },
    applyLoanWrapper: {
        gap: 19,
        marginTop: -20,
        maxHeight:350,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.05)",
        shadowOffset: {
            width: 0,
            height: 27
        },
        shadowRadius: 34,
        shadowOpacity: 1,
        padding:10,
        paddingTop:10,
        borderRadius:15
    },
    applyLoanImage: {
        width: 28,
        height: 28
    },
    mobileViewStyle : {
        width : 330
    }
},
{
        [DEVICE_SIZES.LG]: {
        

        },
        [DEVICE_SIZES.MD]: {
            
        },
        [DEVICE_SIZES.SM]: {
            
        },
        [DEVICE_SIZES.XS]: {
            contentWrapper : {
                flexDirection:"column",
               
            },
            mobileViewStyle : {
                width : 270.6
            },
            applyLoanWrapper :{
                marginTop:10
            }
            
        }
    }
)

